import { FormikErrors } from 'formik'
import { type IEmailCollectionItem, isValidEmail } from '@sales-center/common'

export function validateEmailCollection(
  emails: IEmailCollectionItem[],
  required?: boolean,
  runPestPacValidation?: boolean,
  checkEmailUnique?: boolean,
): FormikErrors<IEmailCollectionItem>[] | undefined {
  const requireEmail = required ?? true
  const emailErrors: FormikErrors<IEmailCollectionItem>[] = []
  const emailSet = new Set<string>()

  emails.map((value, _index) => {
    if (value.emailAddress == '') {
      if (requireEmail && value.isPrimary)
        emailErrors.push({
          emailAddress: 'Primary email must have a value',
          isPrimary: '',
        })
      else {
        if (requireEmail)
          emailErrors.push({ emailAddress: 'Required', isPrimary: '' })
        emailErrors.push({ emailAddress: '', isPrimary: '' })
      }
    } else if (!isValidEmail(value.emailAddress))
      emailErrors.push({ emailAddress: 'Must be a valid email', isPrimary: '' })
    else if (
      runPestPacValidation &&
      emails.some((x) => x.emailAddress.trim().length > 0) &&
      emails
        .map(function (el) {
          return el.emailAddress
        })
        .join('').length > 200
    )
      emailErrors.push({
        emailAddress: 'All email addresses must be under 200 characters',
        isPrimary: '',
      })
    else if (checkEmailUnique && emailSet.has(value.emailAddress)) {
      emailErrors.push({
        emailAddress: 'Each email address must be unique',
        isPrimary: '',
      })
    } else {
      emailSet.add(value.emailAddress)
      emailErrors.push({ emailAddress: '', isPrimary: '' })
    }
  })

  if (emailErrors.findIndex((x) => x.emailAddress !== '') >= 0)
    return emailErrors
  else return undefined
}

export function validateEmailCollectionAddLead(
  emails: IEmailCollectionItem[],
  required?: boolean,
  externalLocationId?: string | undefined,
): FormikErrors<IEmailCollectionItem>[] | undefined {
  const requireEmail = required ?? true
  const emailErrors: FormikErrors<IEmailCollectionItem>[] = []
  const emailSet = new Set<string>()

  emails.map((value, _index) => {
    if (!value?.emailAddress || value.emailAddress.trim() == '') {
      if (requireEmail && value.isPrimary) {
        emailErrors.push({ emailAddress: 'Required', isPrimary: '' })
      } else {
        emailErrors.push({ emailAddress: '', isPrimary: '' })
      }
    } else if (!isValidEmail(value.emailAddress)) {
      emailErrors.push({ emailAddress: 'Must be a valid email', isPrimary: '' })
    } else if (!externalLocationId && emailSet.has(value.emailAddress)) {
      emailErrors.push({
        emailAddress: 'Each email address must be unique',
        isPrimary: '',
      })
    } else {
      emailSet.add(value.emailAddress)
      emailErrors.push({ emailAddress: '', isPrimary: '' })
    }
  })

  if (emailErrors.findIndex((x) => x.emailAddress !== '') >= 0)
    return emailErrors
  else return undefined
}
